<template>
    <div class="hospital-stats-container">
        <!-- 제목/경로 등 필요하면 상단에 추가 -->

        <!-- 날짜 검색 필터 -->
        <div class="search-filter-row">
            <input type="date" v-model="searchStart" />
            <span> ~ </span>
            <input type="date" v-model="searchEnd" />
            <button class="btn search" @click="fetchData">조회</button>
            <button class="btn print" @click="handlePrint">출력</button>
        </div>


    </div>
</template>
<script>

</script>
